import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/home/TeamSection.css';

const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Alisha Rees',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop'
    },
    {
      id: 2,
      name: 'Rhys Carter',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop'
    },
    {
      id: 3,
      name: 'Kyle Buckley',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop'
    },
    {
      id: 4,
      name: 'Maisie Walton',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop'
    }
  ];

  return (
    <section className="team-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Side - Content */}
          <Col lg={6} md={12} className="team-content-col">
            <div className="team-content">
              {/* Main Heading */}
              <h2 className="team-heading">
                Meet Our Creative<br />
                Event Organizer
              </h2>

              {/* Description */}
              <p className="team-description">
                Meet our event organizer which are eligilbe and authentic accordings to your needs.
              </p>

              {/* Learn More Button */}
              <button className="btn-learn-more">
                Learn More
              </button>
            </div>
          </Col>

          {/* Right Side - Team Members Grid */}
          <Col lg={6} md={12} className="team-members-col">
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div 
                  key={member.id} 
                  className="team-member-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="member-photo">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="member-img"
                    />
                  </div>
                  <h4 className="member-name">{member.name}</h4>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TeamSection;